import { AxiosRequestConfig, AxiosResponse } from 'axios';
import querystring from 'querystring';
import { HttpClient, QueryOptions } from './api-types';

const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: options && options.data ? 'post' : 'get',
  };

  if (options) {
    if (options.params) request.params = options.params;
    request.headers = {
      ...request.headers,
      ...options.headers,
    };
    if (options.data) {
      request.data = querystring.stringify(
        options.data as querystring.ParsedUrlQueryInput,
      );
      request.headers = {
        ...request.headers,
        'content-type': 'application/x-www-form-urlencoded',
      };
    }
  }

  return httpClient(request);
};

export const fetchLegalNotices = async (
  httpClient: HttpClient,
  url: string,
): Promise<string> => {
  const response = await queryApi(httpClient, url);
  const { data: result } = response;

  if (!result) throw new Error('Legal Notices URL Error or Missing');

  return result;
};
